import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-fullwidth-normal-scroll',
    templateUrl  : './fullwidth.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedFullwidthNormalScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
